export default "__VITE_ASSET__DJC_UkRy__"